import { Component, Input } from "@angular/core";

@Component({
  selector: "app-carousel-rate-condition",
  templateUrl: "./carousel-rate-condition.component.html",
})
export class CarouselRateConditionComponent {
  @Input() condition!: string;
}
